import { UploadedCustomerMarkup } from '@retail/customer-markup/types';
import {
  recognizedCustomerFactorHeadings,
  recognizedDiscountCodeHeadings,
  recognizedGroupNumberHeadings,
} from './utils';
import {
  ImportColumnConfig,
  ImportSheetConfig,
  spreadsheetDate,
  spreadsheetNumber,
  spreadsheetString,
  useImportItemsStore,
} from '@retail/products/components';
import {
  recognizedMgItemNrHeadings,
  recognizedGtinHeadings,
  recognizedValidFromHeadings,
} from '@retail/utils';
import * as yup from 'yup';

export const useImportCustomerMarkupConditionStore = useImportItemsStore<UploadedCustomerMarkup>;

const columns: ImportColumnConfig<keyof UploadedCustomerMarkup>[] = [
  { name: 'groupNumber', recognizedColumnNames: recognizedGroupNumberHeadings },
  { name: 'groupCode', recognizedColumnNames: recognizedDiscountCodeHeadings },
  { name: 'mgItemNumber', recognizedColumnNames: recognizedMgItemNrHeadings },
  { name: 'gtinCode', recognizedColumnNames: recognizedGtinHeadings },
  { name: 'validFrom', recognizedColumnNames: recognizedValidFromHeadings },
  { name: 'customerFactor', recognizedColumnNames: recognizedCustomerFactorHeadings },
];

const schema = yup.object({
  groupNumber: spreadsheetString().test(
    'length-5',
    'groupNumber must be exactly 5 characters',
    (v) => !v || v.length === 5
  ),
  groupCode: spreadsheetString(),
  mgItemNumber: spreadsheetNumber().test(
    'length-9',
    'mgItemNumber must be exactly 9 digits',
    (v) => v === undefined || String(v).length === 9
  ),
  gtinCode: spreadsheetString(),
  validFrom: spreadsheetDate(),
  customerFactor: spreadsheetNumber().required(),
});

export const customerMarkupImportConfig: ImportSheetConfig<keyof UploadedCustomerMarkup> = {
  columns,
  schema,
};
